export const formatRideMoney = (value, currency = 'VND') => new Intl.NumberFormat('vi-VN', {
  style: 'currency', currency, maximumFractionDigits: 0,
}).format(Number(value || 0));

export const formatRideDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('vi-VN', {
    hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric',
  });
};

export const formatRideAddress = (address) => {
  if (!address) return { primary: '—', secondary: '' };
  const parts = String(address)
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length === 0) return { primary: '—', secondary: '' };
  if (parts.length === 1) return { primary: parts[0], secondary: '' };
  return {
    primary: parts[0],
    secondary: parts.slice(1).join(', '),
  };
};

export const rideErrorMessage = (error, fallback = 'Không thể thực hiện yêu cầu. Vui lòng thử lại.') => (
  error?.response?.data?.message
  || error?.response?.data?.reason
  || error?.response?.data?.detail
  || error?.message
  || fallback
);

export const rideStatusMeta = (status) => ({
  PENDING_DRIVER: { label: 'Chờ tài xế xác nhận', tone: 'warning' },
  CONFIRMED: { label: 'Đã xác nhận', tone: 'success' },
  REJECTED: { label: 'Tài xế từ chối', tone: 'danger' },
  CANCELLED: { label: 'Đã hủy', tone: 'neutral' },
  EXPIRED: { label: 'Đã hết hạn', tone: 'neutral' },
  PICKUP_FAILED: { label: 'Không đón được khách', tone: 'danger' },
}[String(status || '').toUpperCase()] || { label: status || 'Không xác định', tone: 'neutral' });

export const rideTripStatusLabel = (status) => ({
  PUBLISHED: 'Sắp khởi hành',
  BOARDING: 'Đang đón khách',
  IN_PROGRESS: 'Đang di chuyển',
  COMPLETED: 'Đã hoàn thành',
  CANCELLED: 'Chuyến đã hủy',
  EXPIRED: 'Chuyến hết hạn',
  DRIVER_NO_SHOW: 'Tài xế không đến',
}[String(status || '').toUpperCase()] || status || '-');

export const newIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `ride-web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const toLocalDateTimeInput = (date) => {
  const value = new Date(date);
  const shifted = new Date(value.getTime() - value.getTimezoneOffset() * 60000);
  return shifted.toISOString().slice(0, 16);
};

export const customerCancelReasons = [
  ['DRIVER_LATE_OR_NO_SHOW', 'Tài xế đến trễ hoặc không đến'],
  ['DRIVER_UNRESPONSIVE', 'Không liên lạc được với tài xế'],
  ['DRIVER_ASKED_CANCEL', 'Tài xế yêu cầu hủy chuyến'],
  ['CHANGE_OF_PLANS', 'Tôi đổi ý, không cần đi nữa'],
  ['WRONG_BOOKING', 'Tôi đặt nhầm chuyến'],
  ['FOUND_ANOTHER_RIDE', 'Tôi đã tìm được phương tiện khác'],
  ['OTHER', 'Lý do khác'],
];
